import { VideoMetadata } from '../metadata/video-metadata.model';

export class StoryVideoLink {
  public url: string;
  public meta: VideoMetadata;

  constructor(data: any = {}) {
    this.url = data?.url ?? '';
    this.meta = data?.meta ?? {};
  }

  public static createFromApi(data: any = {}): StoryVideoLink {
    const meta = VideoMetadata.createFromApi(data?.meta ?? {});
    return new StoryVideoLink({
      ...data,
      meta,
    });
  }

  public processForApi(): Record<string, any> {
    return {
      url: this.url,
      meta: this.meta.processForApi(),
    }
  }

}
